import { 
    ORDER_DELIV_CANCEL,
    ORDER_DELIV_COMPLETE,
    ORDER_DONE,
    ORDERS_UPDATE
    } from "../../constants/action-types";

export function orderDelivCancel(data){
    return { type: ORDER_DELIV_CANCEL, payload: data } }

export function orderDelivComplete(data){
    return { type: ORDER_DELIV_COMPLETE, payload: data } }

export function orderDone(){
    return { type: ORDER_DONE } }

export function ordersUpdate(data){
    return { type: ORDERS_UPDATE, payload: data } }



// WEBPACK FOOTER //
// ./src/store/actions/orders.js